import { Scale } from 'lucide-react'
import type { ReactNode } from 'react'
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'

type RegulationEmptyPanelProps = {
  title: string
  description: string
  action?: ReactNode
}

export function RegulationEmptyPanel({
  title,
  description,
  action,
}: RegulationEmptyPanelProps) {
  return (
    <Empty className='border border-dashed bg-muted/20'>
      <EmptyHeader>
        <EmptyMedia variant='icon'>
          <Scale aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {action != null && <EmptyContent>{action}</EmptyContent>}
    </Empty>
  )
}
